import { Injectable } from '@angular/core'
import * as moment from 'moment-timezone'

@Injectable()
export class TimeService {

  constructor() {
    moment.tz.setDefault('Europe/Prague')
  }

  getLocalTimeFromUtc(time: string): string {
    return moment(time).format('YYYY-MM-DDTHH:mm:ss')
  }
}

export const getLocalTimeFromUtc = (time: string): string => {
  return moment(time).format('YYYY-MM-DDTHH:mm:ss')
}

export const getCurrentUtcTime = (): string => moment.utc().toJSON()

export const getDurationInHours = (time: string) => moment.duration(time).asHours()

export const getLocalTime = (time) => moment.utc(time, 'HH:mm').local().format('HH:mm')

export const getUtcTime = (time) => moment(time, 'HH:mm').utc().format('HH:mm')



// WEBPACK FOOTER //
// ./src/app/shared/time/time.service.ts